import { useQuery } from '@tanstack/react-query';
import { authApi } from './api';

export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        const res = await authApi.me();
        return res.data;
      } catch {
        return null;
      }
    },
    staleTime: 60_000,
  });
}
